import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Landing
import Home from './modules/landing/Home';
import Whitepaper from './modules/landing/Whitepaper';
import Legal from './modules/landing/Legal';
import Terms from './modules/landing/Terms';
import Docs from './modules/landing/Docs';
import Developers from './modules/landing/Developers';

// Solutions
import Safety from './modules/landing/solutions/Safety';
import Energy from './modules/landing/solutions/Energy';
import Agriculture from './modules/landing/solutions/Agriculture';
import Health from './modules/landing/solutions/Health';
import Fintech from './modules/landing/solutions/Fintech';

// Auth
import Login from './modules/auth/Login';
import Signup from './modules/auth/Signup';
import ForgotPassword from './modules/auth/ForgotPassword';
import VerifyEmail from './modules/auth/VerifyEmail';
import ResetPassword from './modules/auth/ResetPassword';

// Dashboard layout + pages
import DashboardLayout from './modules/app/DashboardLayout';
import Overview from './modules/app/pages/Overview';
import ApiKeys from './modules/app/pages/ApiKeys';
import Usage from './modules/app/pages/Usage';
import Streaming from './modules/app/pages/Streaming';
import Billing from './modules/app/pages/Billing';
import Settings from './modules/app/pages/Settings';

// App
import Chat from './modules/app/Chat';

// Shared
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import RequireAuth from './components/RequireAuth';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        {/* Landing */}
        <Route path="/" element={<Home />} />
        <Route path="/whitepaper" element={<Whitepaper />} />
        <Route path="/legal" element={<Legal />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/developers" element={<Developers />} />

        {/* Solutions */}
        <Route path="/solutions/safety" element={<Safety />} />
        <Route path="/solutions/energy" element={<Energy />} />
        <Route path="/solutions/agriculture" element={<Agriculture />} />
        <Route path="/solutions/health" element={<Health />} />
        <Route path="/solutions/fintech" element={<Fintech />} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Dashboard — protected, layout wraps all sub-pages */}
        <Route element={<RequireAuth><DashboardLayout /></RequireAuth>}>
          <Route path="/dashboard" element={<Overview />} />
          <Route path="/dashboard/keys" element={<ApiKeys />} />
          <Route path="/dashboard/usage" element={<Usage />} />
          <Route path="/dashboard/streaming" element={<Streaming />} />
          <Route path="/dashboard/billing" element={<Billing />} />
          <Route path="/dashboard/settings" element={<Settings />} />
        </Route>

        {/* Chat — protected */}
        <Route path="/chat" element={<RequireAuth><Chat /></RequireAuth>} />
        <Route path="/chat/:convId" element={<RequireAuth><Chat /></RequireAuth>} />

        {/* Fallback */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
